import getPermissions from 'api/permissions';
import { setPermissionCookies } from 'utils/permissions.util';

export function retrieveAndSetPermissions() {
  return getPermissions().then(permissions => {
    if (permissions.length === 0) {
      throw new Error('Authorisation failed for all services');
    }
    setPermissionCookies(permissions);
  });
}
